export interface ILoanSaleTrade {
  id: number
  loanId: string
  tradeType: string
  settled: boolean
  srp: number
  investor?: string
  loanBasis?: number
  salePrice?: number
  msrCap?: number
  realizedGain?: number
  openReceivable?: number
}

export interface ILoanRepurchase {
  id: number
  loanId: string
  repurchasePrice: number
  reason: string
}

export interface IRepurchaseReserve {
  id: number
  reserveAmount: number
  glAccountNo: string
  glBalance?: number
  ties?: boolean
}

export const LOAN_TRADE_TYPES = ['Whole Loan (Svc Rel.)', 'Whole Loan (Svc Ret.)']

export const emptyLoanSaleTrade = (): Partial<ILoanSaleTrade> => ({
  loanId: '',
  tradeType: 'Whole Loan (Svc Rel.)',
  settled: false,
  srp: 0,
})

export const emptyLoanRepurchase = (): Partial<ILoanRepurchase> => ({
  loanId: '',
  repurchasePrice: 0,
  reason: '',
})
